import TC from "@mui/material/TableCell";

import { InfoIcon } from "@/icon/shared";

import { TableCellProps } from ".";
import { Popper } from "../popper";

const TableCell = ({
  children,
  cell,
}: {
  children: React.ReactNode;
  cell: TableCellProps;
}) => (
  <TC
    className={cell.className}
    sx={{ padding: "0 16px", ...cell.style }}
    colSpan={cell.colSpan || 1}
    rowSpan={cell.rowSpan || 1}
    align={cell.align || "center"}
  >
    {children}
  </TC>
);

export const TextTableCell = (cell: TableCellProps) => (
  <TableCell cell={cell}>{cell.label}</TableCell>
);

export const LinkTableCell = (cell: TableCellProps) => {
  const payload = cell.payload as { callback: (symbol: string) => void };
  return (
    <TableCell cell={cell}>
      <div
        className="text-data-primary cursor-pointer select-none underline"
        onClick={() => payload.callback(cell.label as string)}
      >
        {cell.label}
      </div>
    </TableCell>
  );
};

export const AddTableCell = (cell: TableCellProps) => {
  const payload = cell.payload as {
    watched: boolean;
    add: (symbol: string) => void;
    del: (symbol: string) => void;
    watchedText: string;
    notWatchedText: string;
  };

  return (
    <TableCell cell={cell}>
      {payload.watched ? (
        <p
          className="cursor-pointer select-none text-gray-500"
          onClick={() => payload.del(cell.label as string)}
        >
          {payload.watchedText}
        </p>
      ) : (
        <p
          className="text-data-primary cursor-pointer select-none"
          onClick={() => payload.add(cell.label as string)}
        >
          {payload.notWatchedText}
        </p>
      )}
    </TableCell>
  );
};

export const LiTableCell = (cell: TableCellProps) => (
  <TableCell cell={cell}>
    <div
      className={`flex items-center gap-2 ${
        alignment[cell.align || "center"]
      } pl-8`}
    >
      <div className="bg-data-primary h-2 w-2 rounded-full" />
      {cell.label}
    </div>
  </TableCell>
);

const Content = ({ children }: { children: React.ReactNode }) => (
  <div className="text-xs md:text-sm">{children}</div>
);

const alignment = {
  left: "justify-start",
  right: "justify-end",
  center: "justify-center",
};

export const InfoTableCell = (cell: TableCellProps) => {
  const payload = cell.payload as { content: string };

  return (
    <TableCell cell={cell}>
      <div
        className={`flex ${
          alignment[cell.align || "center"]
        } items-center gap-2`}
      >
        {cell.label}
        <Popper
          content={<Content>{payload.content}</Content>}
          hoverable={
            <InfoIcon className="h-5 w-5 fill-[#5A8FD6] transition-colors hover:fill-[#3375cc]" />
          }
        />
      </div>
    </TableCell>
  );
};

export const CustomTableCell = (cell: TableCellProps) => {
  const payload = cell.payload as JSX.Element;
  return <TableCell cell={cell}>{payload}</TableCell>;
};
